import api from '../../utils/api'
import { API_ROOT } from '../../constants'
import { getAreaCurrency, TIMEZONE, getCurrencySymbol } from '../../constants/currency'

const EMAIL_PRICING = {
  $: { price: 72, currency: '$', symbol: '$' },
  '€': { price: 72, currency: '€', symbol: '€' },
  '£': { price: 72, currency: '£', symbol: '£' }
}

export const getEmailPricing = (userCurrency = null) => {
  const currencySymbol = userCurrency ? getCurrencySymbol(userCurrency) : getAreaCurrency(TIMEZONE)
  const pricing = EMAIL_PRICING[currencySymbol] || EMAIL_PRICING['$']

  return {
    price: pricing.price,
    currency: pricing.symbol,
    period: 'year'
  }
}

export const cancelEmailAutoRenewal = async (domain) => {
  const response = await api.post(`${API_ROOT}/v3/custom-mail/email/cancel-auto-renewal`, {
    domain: domain
  })
  return response.data
}

export const enableEmailAutoRenewal = async (domain) => {
  const response = await api.post(`${API_ROOT}/v3/custom-mail/email/enable-auto-renewal`, {
    domain: domain
  })
  return response.data
}

export const fetchEmailAccounts = async (domain) => {
  const response = await api.get(`${API_ROOT}/v3/custom-mail/emails/${domain}`)
  return response.data?.emails || []
}

export const purchaseEmailAccounts = async (payload) => {
  const response = await api.post(`${API_ROOT}/v3/custom-mail/purchase-email`, payload)
  return response
}

export const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    return data.ip
  } catch (error) {
    console.error('Failed to get user IP:', error)
    return '127.0.0.1'
  }
}
